import $http from '@/plugins/axios'
import store from '@/store'
import { LAYOUT_TYPES } from '../store/modules/layout'

export const queryCTF = async (query, checkLastUpdate = true) => {
  let responseCode = 429
  let res
  while (responseCode === 429) {
    try {
      res = await $http().get(buildCTFQuery() + query, { handleError: false })
      responseCode = res.status
    } catch (httpErr) {
      if (httpErr.message.includes('429')) {
        responseCode = 429
        await new Promise(resolve => setTimeout(resolve, 1500))
      } else {
        responseCode = 500
      }
    }
  }

  if (checkLastUpdate && res.includes.Entry) {
    const lastUpdateDates = res.includes.Entry.map(entry => new Date(entry.sys.updatedAt))
    store.dispatch(LAYOUT_TYPES.actions.setPageLastUpdateTime, lastUpdateDates)
  }
  return res
}

/**
 * fetches a single entry from Contentful, useful for nested content
 * @param {String} entryId
 */
export const queryEntryCTF = async (entryId) => {
  let responseCode = 429
  let res
  while (responseCode === 429) {
    try {
      res = await $http().get(buildCTFQuery(entryId), { handleError: false })
      responseCode = res.status
    } catch (httpErr) {
      if (httpErr.message.includes('429')) {
        responseCode = 429
        await new Promise(resolve => setTimeout(resolve, 1500))
      } else {
        responseCode = 500
      }
    }
  }
  const lastUpdate = [store.state.layout.pageLastUpdatedDate]
  store.dispatch(LAYOUT_TYPES.actions.setPageLastUpdateTime, lastUpdate)
  return res
}

export const downloadAssetCTF = async (assetId) => {
  return await $http().get(getUrl() + `/spaces/${process.env.VUE_APP_CTF_SPACE}/environments/${process.env.VUE_APP_CTF_ENV}/assets/${assetId}?access_token=${getToken()}`)
}

const buildCTFQuery = (entityId = '') => {
  return getUrl() + `/spaces/${process.env.VUE_APP_CTF_SPACE}/environments/${process.env.VUE_APP_CTF_ENV}/entries${entityId ? '/' + entityId : ''}?access_token=${getToken()}`
}

const getToken = () => {
  let inPreviewMode = false
  if (localStorage.contentPreview) {
    try {
      inPreviewMode = JSON.parse(localStorage.contentPreview)
    } catch (e) {
      console.log(`Failed to parse contentPreview (defaulting to published (live site)): ${e}`)
    }
  }
  return inPreviewMode ? process.env.VUE_APP_CTF_PREVIEW_TOKEN : process.env.VUE_APP_CTF_TOKEN
}

const getUrl = () => {
  let inPreviewMode = false
  if (localStorage.contentPreview) {
    try {
      inPreviewMode = JSON.parse(localStorage.contentPreview)
    } catch (e) {
      console.log(`Failed to parse contentPreview (defaulting to published (live site)): ${e}`)
    }
  }
  return inPreviewMode ? process.env.VUE_APP_CTF_API_PREVIEW_URL : process.env.VUE_APP_CTF_API_URL
}

export const sortCTFEntries = (links, entries) => {
  if (!links || !entries) {
    return
  }
  // sort includes entries by group tile order
  const sliceIds = links.map(s => s.sys.id)
  return [...entries]
    .filter(e => sliceIds.includes(e.sys.id))
    .map(e => {
      e.sys.order = sliceIds.indexOf(e.sys.id)
      return e
    }).sort((a, b) => a.sys.order - b.sys.order)
}

/**
 * @param {String} id Id of desired asset
 * @param {Array} assets Contentful assets array
 */
export const getCTFAsset = (id, assets) => {
  if (!id || !assets || !assets.length) {
    return
  }
  return assets.find((a) => a.sys.id === id)
}
